import { DateRange } from "react-day-picker";

export const transformSortValues = (val: string) : {
  sortField: string;
  sortOrder: string;
} => {
  let obj : {
    sortField: string;
    sortOrder: string;
  } = {
    sortField: 'created_at',
    sortOrder: 'desc'
  }
  if(val.includes('asc')){
    obj.sortField = val.split('-')[0];
    obj.sortOrder = 'asc';
  }else{
    obj.sortField = val.split('-')[0];
    obj.sortOrder = 'desc';
  }
  return obj;
}

export const transformDateValues = (val: DateRange | undefined) : {
  start: string;
  end: string;
} => {
  let obj : {
    start: string;
    end: string;
  } = {
    start: '',
    end: ''
  }
  if(val){
    obj.start = val.from?.toLocaleDateString("en-CA") ?? "";
    obj.end = val.to?.toLocaleDateString("en-CA") ?? "";
  }
  return obj;
}
